import {
  Box,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { LinkIcon } from 'src/assets/icons'

import { IUserRefferalResponse } from 'src/types'

import { HelperWrapper } from 'src/components/helper-wrapper'
import {
  getPolygonscanAddressUrl,
  getTableTimestamp,
  shortenStringMiddle2,
  truncateString,
} from 'src/common/utils'

import { useStyles } from './../styles'
import { useCopy } from 'src/hooks'

interface IProps {
  item: IUserRefferalResponse
  timezone?: string
}

export const ReferralsTableItem = ({ item, timezone }: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleCopy = useCopy(item.default_wallet)

  return (
    <TableRow key={item.id}>
      <TableCell sx={{ px: isTablet ? '4px' : '16px' }}>
        {/* <Tooltip title={item?.name || item.email}> */}
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: '6px', justifyContent: 'center' }}
        >
          {item?.name && (
            <Typography sx={{ fontSize: isTablet ? '10px' : '14px' }}>
              {isTablet ? truncateString(item.name, 18) : item?.name}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              justifyContent: 'start',
            }}
          >
            <Tooltip title={item.default_wallet}>
              <Typography sx={{ fontSize: isTablet ? '9px' : '12px' }}>
                {shortenStringMiddle2(item.default_wallet, isTablet ? 11 : 25, '...')}
              </Typography>
            </Tooltip>
            <Box sx={{ display: 'flex', gap: isTablet ? '0px' : '3px' }}>
              <IconButton
                disabled={!item.default_wallet}
                size="small"
                component={Link}
                href={item.default_wallet ? getPolygonscanAddressUrl(item.default_wallet) : '#'}
                target="_blank"
              >
                <LinkIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
              </IconButton>

              <IconButton size="small" disabled={!item.default_wallet} onClick={handleCopy}>
                <ContentCopyIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
              </IconButton>
            </Box>
          </Box>
        </Box>
        {/* </Tooltip> */}
      </TableCell>
      {/* <TableCell sx={{ px: isTablet ? '4px' : '16px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            justifyContent: 'start',
          }}
        >
          <Tooltip title={item.default_wallet}>
            <Typography sx={{ fontSize: isTablet ? '10px' : '14px' }}>
              {shortenStringMiddle2(item.default_wallet, isTablet ? 11 : 25, '...')}
            </Typography>
          </Tooltip>
          <Box sx={{ display: 'flex', gap: isTablet ? '0px' : '3px' }}>
            <IconButton
              disabled={!item.default_wallet}
              size="small"
              component={Link}
              href={item.default_wallet ? getPolygonscanAddressUrl(item.default_wallet) : '#'}
              target="_blank"
            >
              <LinkIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
            </IconButton>

            <IconButton size="small" disabled={!item.default_wallet} onClick={handleCopy}>
              <ContentCopyIcon className={isTablet ? classes.copyIconSmall : classes.copyIcon} />
            </IconButton>
          </Box>
        </Box>
      </TableCell> */}
      <TableCell
        align="center"
        sx={{ px: isTablet ? '0px' : '16px', fontSize: isTablet ? '10px' : '14px' }}
      >
        {item.numberOfScans || 0}
      </TableCell>

      <TableCell
        align="center"
        sx={{
          px: isTablet ? '4px' : '16px',
          fontSize: isTablet ? '8px' : '10px',
        }}
      >
        {getTableTimestamp({ date: item?.created_at, timezone: timezone })}
      </TableCell>
    </TableRow>
  )
}
